import * as z from "zod";

export const OffersConfigSchema = z.object({
  autoConvertCurrency: z.boolean().optional(),
});

export type OffersConfig = z.infer<typeof OffersConfigSchema>;
